import {useTranslation} from "react-i18next";

export const useOnboardingHandling = () => {
    const {t: translation} = useTranslation('onboarding');

    const getCountryCode = () => {
        return '+49';
    }

    const removeNumberPrefix = (phoneNumber: string) => {
        const prefix: string = getCountryCode()
        if (phoneNumber.startsWith(prefix)) {
            return phoneNumber.slice(prefix.length);
        }
        return phoneNumber;
    }

    return {
        translation,
        getCountryCode,
        removeNumberPrefix,
    }
}